import React, { useContext, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { ApplicationContext } from "@context/ApplicationContext";
import { ProfileContext } from "@context/ProfileContext";
import AddEmailForm from "@components/Form/AddEmailForm";
import VersionedLayout from "@components/Wrappers/VersionedLayout/index.js";

const AddEmailPage = () => {
    const { whiteLabel } = useContext(ApplicationContext);
    const { updateEmailList, emailList, processing } = useContext(ProfileContext);

    useEffect(() => {
        updateEmailList();
    }, [processing]);

    const brand = whiteLabel?.brand_name;
    const enableEmailForm = whiteLabel?.subscriber_group?.subscriber_email_maintenance ?? false;
    const uniqueEmailList = emailList.filter(
        (email, index, self) => index === self.findIndex((e) => e.email === email.email)
    );

    return (
        <VersionedLayout>
            <Helmet>
                <title>{`Manage Your Email | ${brand}`}</title>
                <meta name="keywords" content={`Manage Your Email | ${brand}`} />
                <meta name="description" content={`Sign up for a ${brand}
                account with your personal email address to get access
                to the membership offers & discounts available. Sign up today!`} />
                <link rel="canonical" href={`${window.location.protocol}//${window.location.host}/user/email-add`} />
            </Helmet>
            <div className="form__wrapper">
                <h1 className="main-heading">My  Email</h1>
                <div className="form__email-please-note">
                    <p className="paragraph">Please note: The current email is always in bold and labelled &quot;default&quot;.</p>
                </div>
                <div className="email__list">
                    {uniqueEmailList.length > 0 ? (
                        uniqueEmailList.map((email) => (
                            <div className={`email__item ${email.is_default ? "email__default" : ""}`} key={email.id}>
                                {email.email}
                                {email.is_default ? <span> - default</span> : null}
                                {email.email_verified === false ? <span> - NOT VERIFIED!</span> : null}
                            </div>
                        ))
                    ) : (
                        <p className="no-results">
                            No email loaded/found.
                        </p>
                    )}
                </div>
                {enableEmailForm ? (
                    <AddEmailForm />
                ): null}

            </div>
        </VersionedLayout>
    );
};
export default AddEmailPage;
